import axios, { type AxiosError, type AxiosResponse, type AxiosRequestConfig, type AxiosInstance, type RawAxiosResponseHeaders } from "axios";
import { axiosRequestConfig } from "@/../config/swr.config";

function capitalize(text: string) {
  if (!text || text.length === 0) return "";

  return `${text[0].toUpperCase()}${text.slice(1)}`;
}

export class ApiClient {
  constructor(
    private instance: AxiosInstance,
    private additionalHeaders?: RawAxiosResponseHeaders | (() => RawAxiosResponseHeaders)
  ) {}

  protected get headers() {
    return typeof this.additionalHeaders === "function" ? this.additionalHeaders() : this.additionalHeaders;
  }

  request = <D, R = any>(config: AxiosRequestConfig<D>) =>
    this.instance
      .request<R>(config)
      .then((res: AxiosResponse) => res.data as R)
      .catch((err: AxiosError<{ error: string }>) => {
        throw new Error(capitalize(err.response?.data?.error ?? err.toString()));
      });

  rawRequest = <D, R = any>(config: AxiosRequestConfig<D>) => this.instance.request<R>(config);

  get = <R, D = any>(url: string, params: AxiosRequestConfig<D>["params"] = undefined, config: AxiosRequestConfig<D> = {}) =>
    this.request<D, R>({ ...config, method: "GET", url, params, headers: this.headers });
  post = <R, D = any>(url: string, data: AxiosRequestConfig<D>["data"] = undefined, config: AxiosRequestConfig<D> = {}) =>
    this.request<D, R>({ ...config, method: "POST", url, data, headers: this.headers });
  delete = <R, D = any>(url: string, data: AxiosRequestConfig<D>["data"] = undefined, config: AxiosRequestConfig<D> = {}) =>
    this.request<D, R>({ ...config, method: "DELETE", url, data, headers: this.headers });
  put = <R, D = any>(url: string, data: AxiosRequestConfig<D>["data"] = undefined, config: AxiosRequestConfig<D> = {}) =>
    this.request<D, R>({ ...config, method: "PUT", url, data, headers: this.headers });
}

export const httpClient = axios.create(axiosRequestConfig.v2);
export const apiV2 = new ApiClient(httpClient);
